import {httpRequest} from "./http-request";

export const edoService = {
  getAccounts,
  authByLogin,
  authShipperByLogin,
  authConfirm,
  getCompanies,
  sendDraft,
  getDocs,
  getContact,
  getTypes,
  getShipperAccounts,
};

async function getTypes()
{
  return await httpRequest
    .get(`edo/get-types`)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getAccounts()
{
  return await httpRequest
    .get(`edo/get-accounts`)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function authByLogin(type, username, password)
{
  const formData = new FormData();
  formData.append("type", type);
  formData.append("username", username);
  formData.append("password", password);

  return await httpRequest
    .post('edo/auth-by-login', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function authShipperByLogin(type, username, password, shipperCompanyId, priority)
{
  const formData = new FormData();
  formData.append("type", type);
  formData.append("username", username);
  formData.append("password", password);
  formData.append("shipperCompanyId", shipperCompanyId)
  formData.append("priority", priority);

  return await httpRequest
    .post('edo/auth-shipper-by-login', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function authConfirm(type, tmpSession, tmpKey, code)
{
  const formData = new FormData();
  formData.append("type", type);
  formData.append("tmpSession", tmpSession);
  formData.append("tmpKey", tmpKey);
  formData.append("code", code);

  return await httpRequest
    .post('edo/auth-confirm', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

/**
 * Получение списка зарегистрированных компаний Edo API
 * @returns {Promise<any>}
 */
async function getCompanies(legalEntityId = '') {
  return await httpRequest
    .get(`edo/get-companies?legalEntityId=${legalEntityId}`)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function sendDraft(abonentId, type, orderId, contractId, recipient)
{
  const formData = new FormData();
  formData.append("abonentId", abonentId);
  formData.append("type", type);
  formData.append("orderId", orderId);
  formData.append("contractId", contractId);
  formData.append("recipient", recipient);


  return await httpRequest
    .post('edo/send-draft', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getContact(abonentId, orderId, contractId)
{
  const formData = new FormData();
  formData.append("abonentId", abonentId);
  formData.append("orderId", orderId);
  formData.append("contractId", contractId);

  return await httpRequest
    .post('edo/get-contact', formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    )
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getShipperAccounts() {
  return await httpRequest
    .get(`edo/get-shipper-accounts`)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}

async function getDocs(orderId, contractId) {
  return await httpRequest
    .get(`edo/get-docs?orderId=${orderId}&contractId=${contractId}`)
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve(response.data);
      }

      return Promise.reject(httpRequest.getDefaultMessageError());
    });
}